/**
 * Decodes HTML entities in a string via a temporary DOM element.
 * @param {string | null | undefined} input
 * @returns {string | null | undefined}
 */
const htmlDecode = (input) => {
    if (input == null || input === '') {
        return input;
    }
    const e = document.createElement('div');
    e.innerHTML = input;
    if (e.childNodes.length === 1 && e.childNodes[0].nodeType === Node.TEXT_NODE) {
        return e.childNodes[0].nodeValue;
    }
    return e.innerHTML;
};
export default htmlDecode;
